import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface SelectFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: {
    value: string;
    label: string;
  }[];
  placeholder?: string;
  required?: boolean;
}
export function SelectField({
  label,
  value,
  onChange,
  options,
  placeholder = 'Select...',
  required = false
}: SelectFieldProps) {
  return <div className="flex flex-col gap-1" data-id="element-129">
      <label className="text-sm font-medium text-gray-700" data-id="element-130">
        {label}
        {required && <span className="text-red-500 ml-1" data-id="element-131">*</span>}
      </label>
      <div className="relative" data-id="element-132">
        <select value={value} onChange={e => onChange(e.target.value)} required={required} className="w-full px-3 py-1.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent appearance-none bg-white pr-10" data-id="element-133">
          <option value="" data-id="element-134">{placeholder}</option>
          {options.map(option => <option key={option.value} value={option.value} data-id="element-135">
              {option.label}
            </option>)}
        </select>
        <ChevronDownIcon className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" data-id="element-136" />
      </div>
    </div>;
}